import VDatePickerSchedule from './index.vue';

export default {
  install: (Vue) => Vue.component('VDatePickerSchedule', VDatePickerSchedule),
};
